// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Navbar-NavbarDivider-module--cls1--4H2u2","cls2":"Navbar-NavbarDivider-module--cls2--3ToId Navbar-NavbarDivider-module--cls1--4H2u2"};